import React from 'react';
import { TextButton, Text } from '@zillow/constellation';
import styled from 'styled-components';
import { SourcePage } from './types/compose-types';
import DocumentThumbnailHorizontalViewer from './DocumentThumbnailHorizontalViewer';

const PagesPanelContainer = styled.div`
  display: flex;
  overflow-y: auto;
  height: 100%;
  flex-direction: column;
  width: 65%;
`;

const SectionText = styled(Text)`
  display: block;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
`;

const DocumentThumbnailViewerContainer = styled.div`
  overflow-y: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1rem;
  background-color: ${props => props.theme.constellation.colors.grey};
`;

type PageSelectionPanelProps = {
  documentId: string;
  documentName: string;
  sourcePages: Array<SourcePage>;
  onPageSelected: (page: SourcePage, shift: boolean) => void;
  onPageRotation: (page: SourcePage) => void;
  onSelectAllPages: () => void;
};
const PageSelectionPanel = function ({
  documentId,
  documentName,
  sourcePages,
  onPageSelected,
  onPageRotation,
  onSelectAllPages,
}: PageSelectionPanelProps) {
  return (
    <PagesPanelContainer>
      <SectionText fontType="bodySmall">
        Use Shift to select continuous pages or{' '}
        <TextButton onClick={onSelectAllPages}>Select All</TextButton>
      </SectionText>
      <DocumentThumbnailViewerContainer>
        <DocumentThumbnailHorizontalViewer
          documentId={documentId}
          documentName={documentName}
          pages={sourcePages}
          onPageSelected={onPageSelected}
          onPageRotation={onPageRotation}
        />
      </DocumentThumbnailViewerContainer>
    </PagesPanelContainer>
  );
};

export default PageSelectionPanel;
